(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-password-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-password-form.js');
"use strict";


const {
  useContext,
  Fragment
} = React;
const {
  EDIT_MODE_PASSWORD
} = svs.ticket_partner.companyDetails.constants.actions;
const {
  CANCEL_LABEL,
  SAVE_LABEL,
  PASSWORD_LABEL
} = svs.ticket_partner.companyDetails.constants.TEXTS;
const {
  HEADER,
  PASSWORD
} = svs.ticket_partner.companyDetails.constants.TEXTS.CHANGE_PASSWORD;
const {
  ButtonRow
} = svs.ticket_partner.sharedComponents.buttonRow;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const Icon = svs.ui.ReactIcon;
const {
  INFO_TEXT
} = svs.ticket_partner.companyDetails.constants.TEXTS;
const CompanyDetailsPasswordForm = () => {
  const ChangePasswordForm = svs.ticket_partner.changePassword.ChangePasswordForm;
  const {
    dispatch,
    state
  } = useContext(svs.ticket_partner.CompanyDetailsContext);
  const {
    edit: passwordEdit
  } = state.password;
  const saveAndCancelBtnsPass = [{
    className: 'margin-right-1',
    label: CANCEL_LABEL,
    key: 'cancel-btn',
    transparent: true,
    onClick: e => {
      e.preventDefault();
      dispatch({
        type: EDIT_MODE_PASSWORD,
        payload: {
          edit: false
        }
      });
    }
  }, {
    label: SAVE_LABEL,
    key: 'save-btn',
    focus: true,
    type: 'submit'
  }];
  const editPassBtn = [{
    label: PASSWORD_LABEL,
    key: 'edit-btn',
    focus: true,
    onClick: e => {
      e.preventDefault();
      dispatch({
        type: EDIT_MODE_PASSWORD,
        payload: {
          edit: true
        }
      });
    }
  }];
  const onPasswordChanged = () => {
    dispatch({
      type: EDIT_MODE_PASSWORD,
      payload: {
        edit: false
      }
    });
  };
  return React.createElement(GridCol, {
    className: "u-text-left",
    md: 6,
    sm: 12
  }, React.createElement("h2", null, HEADER), passwordEdit ? React.createElement(ChangePasswordForm, {
    customButtons: saveAndCancelBtnsPass,
    isLessSpace: true,
    isVertical: false,
    onPasswordChanged: onPasswordChanged
  }) : React.createElement(Fragment, null, React.createElement("div", null, PASSWORD), React.createElement(ButtonRow, {
    buttons: editPassBtn,
    className: "margin-top-2"
  })), React.createElement(Fragment, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement("div", {
    className: "u-flex u-flex-align-items-center "
  }, React.createElement(Icon, {
    icon: "information"
  }), React.createElement("p", {
    className: "f-bold f-small f-margin-0 margin-top-2 margin-left-1 margin-right-1"
  }, INFO_TEXT)))));
};
svs.ticket_partner.companyDetails.components.CompanyDetailsPasswordForm = CompanyDetailsPasswordForm;

 })(window);